import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js'
import './App.css';
import './index.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthProvider } from './Auth';
import { Route, Routes } from 'react-router-dom';
import { TemplateMain } from './Componentes/Templates/Main';
import { TemplateAdmin } from './Componentes/Templates/Admin';
import { Index } from './Componentes/Index';
import { Home } from './Componentes/Admin/Home';
import { Home as Paginas } from "./Componentes/Admin/Pages/Home";
import { Home as Plantillas } from "./Componentes/Admin/Templates/Home";
import { Home as Contenidos } from "./Componentes/Admin/Contents/Home";
import { Home as Tags } from "./Componentes/Admin/Tags/Home";
import { Edit as EditarContenido } from "./Componentes/Admin/Contents/Edit";
import { Edit as EditarPagina } from "./Componentes/Admin/Pages/Edit";
import { Edit as EditarPlantilla } from "./Componentes/Admin/Templates/Edit";
import { Container, Alert } from 'react-bootstrap';


function App() {
	return <AuthProvider>
		<Routes>
			<Route path="/admin" element={<TemplateAdmin />}>
				<Route key="index" index element={<Home />} />
				<Route path="contents" key="contents" element={<Contenidos />} />
				<Route path="contents/edit/:id?" key={"edit"} element={<EditarContenido />} />

				<Route path="pages" key="pages" element={<Paginas />}></Route>
				<Route path="pages/edit/:id?" key={"edit"} element={<EditarPagina />} />

				<Route path="templates" key="templates" element={<Plantillas />}></Route>
				<Route path="templates/edit/:id?" key={"edit"} element={<EditarPlantilla />} />

				<Route path="tags" key="tags" element={<Tags />}></Route>

				<Route path="*" element={<Container className='mt-4'><Alert variant="danger">No encontrado</Alert></Container>} />
			</Route>

			<Route path="/" element={<TemplateMain />}>
				<Route path='/:id?' element={<Index />} />
			</Route>
		</Routes>
	</AuthProvider>
}

export default App;
